module.exports = __webpack_public_path__ + "static/media/PK.e20d85a1.png";